import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { Navbar } from './common/components/Navbar';
import { Login } from './features/auth';
import { Register } from './features/admin';
import { PepsiCoRag, PepsiCoRagChat } from './features/rag';
import { ProtectedRoute, AdminRoute, UserOrAdminRoute } from './common/guards';
import './App.css';

const AppContent: React.FC = () => {
return (
  <>
    <link rel="stylesheet" href="https://unpkg.com/@progress/kendo-font-icons/dist/index.css" />
    <div className="App">
      <Navbar />
        <main role="main">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register"
              element={
                <AdminRoute>
                  <Register />
                </AdminRoute>
              }
            />
            <Route
              path="/pepsico-rag"
              element={
                <UserOrAdminRoute>
                  <PepsiCoRag />
                </UserOrAdminRoute>
              }
            />
            <Route
              path="/pepsico-rag-chat"
              element={
                <UserOrAdminRoute>
                  <PepsiCoRagChat />
                </UserOrAdminRoute>
              }
            />
            <Route path="*" element={<Navigate to="/pepsico-rag" replace />} />
          </Routes>
        </main>
      </div>
    </>
  );
};

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
}

export default App;
